module.exports = __webpack_public_path__ + "media/images/company_3-65637577a4fbed0fe537997ebb058ec2.png";